import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  user: {
    name: '',
    token: '',
    uid: '',
    imgUrl: '',
    email: '',
    role: ''
  },
  space: '',
  permissions: {
    permission: '',
    codes: []
  },
  show: {
    spaceList: false,
    other: '',
    left: true,
    box: '',
    msg: false,
    floating: false
  },
  updateEl: '',
  notice: {
    alertAlive: false,
    alertWarn: false,
    newPkg: [],
    donePkg: 0,
    infoKick: false
  },
  el: {
    newFile: false,
    maxFile: '',
    sentFile: false,
    showLang: false,
    showDown: false,
    // passDown: false,
    startTransfer: '',
    showDownMsg: null,
  },
  clearKeep: false,
  userInfo: {
    id: '',
    token: '',
    role: ''
  },
  project: {
    id: ''
  },
  app: {
    versionCheck: false,
    info: {
      newVersion: '',
      appVersion: '',
      downloadUrl: ''
    },
    show: false,
    type: false,
    login: null,
    size: 'max'
  },
  transfer: {
    aliveList: {
      tasks: []
    },
    transferShow: {
      show: false,
      type: 'upload'
    }
  },
  scroll: 0,
  size: {
    height: 0,
    width: 0
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
